unit View.Vendas.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,
  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,
  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,
  XData.Web.JsonDataset,
  Grid.Plugins,
  Crud.Utils,
  UConstantes,
  UUtils,
  UPersonalizacao_Tabela.Interfaces,
  UPersonalizacao_Tabela, System.StrUtils, System.DateUtils, UFrameDataBase,
  Vcl.Forms, XData.Web.Client, UHelperServer;

type
  TFViewVendasList = class(TForm)
    VendasDataset: TXDataWebDataSet;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    VendasDatasetid: TIntegerField;
    VendasDatasetcfop_cfop: TStringField;
    VendasDatasetnumero: TStringField;
    VendasDatasetmodelo: TStringField;
    VendasDatasetserie: TStringField;
    VendasDatasetdata_emissao: TDateTimeField;
    VendasDatasetdata_saida: TDateTimeField;
    VendasDatasetvalor_total: TFloatField;
    VendasDatasetcodigo_interno: TIntegerField;
    VendasDatasetexcluido: TBooleanField;
    VendasDatasetinclusao: TDateTimeField;
    VendasDatasetalteracao: TDateTimeField;
    VendasDatasetexclusao: TDateTimeField;
    btnExportarExcel: TButton;
    VendasDatasetfuncionarionome: TStringField;
    VendasDatasetclienterazao_social_nome: TStringField;
    edtDataInicial: TDateTimePicker;
    edtDataFinal: TDateTimePicker;
    cbbVendasSimplesFaturamento: TComboBox;
    cbxVendasExcluidos: TCheckBox;
    edtVendasCfop: TEdit;
    edtClienteNome: TEdit;
    btnPesquisarCliente: TButton;
    btnPesquisarVenda: TButton;
    frmBanco: TfrmDataBase;
    VendasDatasetnfexml_s3: TStringField;
    VendasDatasetnfe_id: TIntegerField;
    VendasDatasetnfeanexo_sincronizado: TXDataWebDatasetField;
    XDataWebClient: TXDataWebClient;
    cbbVendasNfe: TComboBox;
    VendasDatasetnfechave_acesso: TStringField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure edtVendasCfopKeyPress(Sender: TObject; var Key: Char);
    procedure btnPesquisarVendaClick(Sender: TObject);
    procedure XDataWebClientError(Error: TXDataClientError);
    procedure XDataWebClientLoad(Response: TXDataClientResponse);
    procedure btnPesquisarClienteClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    procedure ConfigurarData;
    function GetFiltro : string;
    function ValidarDatas : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewVendasList: TFViewVendasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewVendasList }

procedure TFViewVendasList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(VendasDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewVendasList.btnPesquisarClienteClick(Sender: TObject);
begin
  THelperServer.ChamarConsulta('Clientes', 'clientes', edtClienteNome);
end;

procedure TFViewVendasList.btnPesquisarVendaClick(Sender: TObject);
begin
  ValidarDatas;

  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewVendasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewVendasList.ConfigurarData;
begin
  edtDataFinal.Max := Date;
  edtDataInicial.Min := IncDay(Date, -365);
  edtDataInicial.Date := IncDay(Date, -365);
  edtDataFinal.Date := Date;
end;

class function TFViewVendasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewVendasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewVendasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewVendasList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewVendasList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewVendasList.edtVendasCfopKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

function TFViewVendasList.GetFiltro: string;
var
  lListaFiltro : TStringList;
  lFiltroBanco : string;
begin
  Result := EmptyStr;
  lListaFiltro := TStringList.Create;

  try
    case cbbVendasSimplesFaturamento.ItemIndex of
      1: lListaFiltro.Add('(simples_faturamento eq true)');
      2: lListaFiltro.Add('(simples_faturamento eq false)');
    end;

    if not cbxVendasExcluidos.Checked then
      lListaFiltro.Add('(excluido eq false)');

    if edtClienteNome.Tag <> 0 then
      lListaFiltro.Add('(cliente_id eq '+edtClienteNome.Tag.ToString+')');

    if not Trim(edtVendasCfop.Text).IsEmpty then
      lListaFiltro.Add('(cfop_cfop eq '+QuotedStr(edtVendasCfop.Text)+')');

    if ((edtDataInicial.Text <> '') and (edtDataFinal.Text <> '')) then
    begin
      lListaFiltro.Add('((data_emissao ge '+edtDataInicial.Text+') and ' +
        '(data_emissao le '+edtDataFinal.Text+'))');
    end;

    lFiltroBanco := frmBanco.GetFilterDataBase;

    if not lFiltroBanco.IsEmpty then
      lListaFiltro.Add('(data_base_id eq '+lFiltroBanco+')');

    case cbbVendasNfe.ItemIndex of
      1: lListaFiltro.Add('(nfe_id ne null)');
      2: lListaFiltro.Add('(nfe_id eq null)');
    end;

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

procedure TFViewVendasList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

function TFViewVendasList.ValidarDatas: string;
begin
  Result := EmptyStr;

  if (Trim(edtDataInicial.Text).IsEmpty) or (Trim(edtDataFinal.Text).IsEmpty) then
  begin
    Result := 'Data inicial e final são obrigatórias!';
    Exit;
  end;

  if edtDataInicial.Date > edtDataFinal.Date then
  begin
    Result := 'A data inicial deve ser menor que a final!';
    Exit;
  end;

  if DaysBetween(edtDataInicial.Date, edtDataFinal.Date) > 365 then
  begin
    Result := 'O intervalo entre as datas deve ser menor ou igual a 1 ano!';
    Exit;
  end;
end;

procedure TFViewVendasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordNfeId,
  RecordVendaId : Integer;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure BaixarArquivoButtonClick(Sender: TObject);
  var
    lBotaoSelecionado : TButton;
    lJson : TJSObject;
    lBotaoNome : string;
  begin
    TUtils.ChamarDivLoading;

    lBotaoSelecionado := TButton(Sender);
    lBotaoNome := lBotaoSelecionado.Name;

    lJson := TJSObject.New;

    if lBotaoNome = 'rbtBaixarXml'  then
      lJson['tipo'] := 'xml'
    else if lBotaoNome = 'rbtBaixarDanfe' then
      lJson['tipo'] := 'danfe'
    else
    begin
      lJson['tabela'] := 'vendas';
      lJson['tipo'] := 'relatorio'
    end;

    lJson['codigo'] := lBotaoSelecionado.Tag;

    if lBotaoNome <> 'rbtBaixarRelatorio' then
      lJson['tabela'] := 'nfe';

    XDataWebClient.RawInvoke('IService.BaixarArquivo', [lJson]);
  end;

var
  Button: TButton;
  lHabilitarDanfeXml : Boolean;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      VendasDataset.Connection.Model.DefaultSchema.FindEntityType(VendasDataset.EntitySetName),
      VendasDataset.CurrentData
    );

    RecordNfeId := VendasDataset.FieldByName('nfe_id').AsInteger;
    RecordVendaId := VendasDataset.FieldByName('id').AsInteger;

    lHabilitarDanfeXml := not VendasDataset.FieldByName('nfe.xml_s3').AsString.IsEmpty and
      (VendasDataset.FieldByName('nfe.anexo_sincronizado').AsString = '1');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_venda');

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarXml';
    Button.Tag := RecordNfeId;
    Button.Caption := '<i class="fas fa-file-code"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_xml');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar XML');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarDanfe';
    Button.Tag := RecordNfeId;
    Button.Caption := '<i class="fas fa-file-pdf"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_danfe');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar Danfe');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarRelatorio';
    Button.Tag := RecordVendaId;
    Button.Caption := '<i class="fas fa-file-alt"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_relatorio');
    Button.OnClick := @BaixarArquivoButtonClick;
    Button.ElementClassName := 'btn btn-link btn-info btn-lg';
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Baixar Relatório');
  end;
end;

procedure TFViewVendasList.WebDBTableControl1GetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['numero', 'funcionario.nome',
     'cliente.razao_social_nome', 'valor_total']) of
      0, 1, 2: AClassName := 'text-start';
      3: AClassName := 'text-end'
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewVendasList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
     0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>';
      end;
    end;
  end;
end;

procedure TFViewVendasList.WebFormCreate(Sender: TObject);
begin
  ConfigurarData;
  frmBanco.ConfigurarDataBase;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('vendas', 'active');
  TUtils.SetValorDicionarioClasses('vendas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_vendas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, VendasDataset, lcPaginator,
    lbPaginationInfo);
  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'codigo_interno desc';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewVendasList.XDataWebClientError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewVendasList.XDataWebClientLoad(Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := Response.ResultAsObject;
  THelperServer.BaixarAnexo(string(lJSONObject['arquivo_base64']), string(lJSONObject['arquivo_nome']));
end;

procedure TFViewVendasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.vendas.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.vendas.list.table');
  cbPageSize := TComboBox.Create('view.vendas.list.cbPageSize');
  edSearch := TEdit.Create('view.vendas.list.search');
  lcPaginator := TListControl.Create('view.vendas.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  edtDataInicial := TDateTimePicker.Create('edtDataInicial');
  edtDataFinal := TDateTimePicker.Create('edtDataFinal');
  cbbVendasSimplesFaturamento := TComboBox.Create('cbbVendasSimplesFaturamento');
  cbxVendasExcluidos := TCheckBox.Create('cbxVendasExcluidos');
  edtVendasCfop := TEdit.Create('edtVendasCfop');
  edtClienteNome := TEdit.Create('edtClienteNome');
  btnPesquisarCliente := TButton.Create('btnPesquisarCliente');
  btnPesquisarVenda := TButton.Create('btnPesquisarVenda');
  frmBanco := TfrmDataBase.Create(Self);
  cbbVendasNfe := TComboBox.Create('cbbVendasNfe');
  VendasDataset := TXDataWebDataSet.Create(Self);
  VendasDatasetcodigo_interno := TIntegerField.Create(Self);
  VendasDatasetnumero := TStringField.Create(Self);
  VendasDatasetclienterazao_social_nome := TStringField.Create(Self);
  VendasDatasetdata_emissao := TDateTimeField.Create(Self);
  VendasDatasetdata_saida := TDateTimeField.Create(Self);
  VendasDatasetvalor_total := TFloatField.Create(Self);
  VendasDatasetcfop_cfop := TStringField.Create(Self);
  VendasDatasetmodelo := TStringField.Create(Self);
  VendasDatasetserie := TStringField.Create(Self);
  VendasDatasetfuncionarionome := TStringField.Create(Self);
  VendasDatasetnfechave_acesso := TStringField.Create(Self);
  VendasDatasetexcluido := TBooleanField.Create(Self);
  VendasDatasetinclusao := TDateTimeField.Create(Self);
  VendasDatasetalteracao := TDateTimeField.Create(Self);
  VendasDatasetexclusao := TDateTimeField.Create(Self);
  VendasDatasetid := TIntegerField.Create(Self);
  VendasDatasetnfe_id := TIntegerField.Create(Self);
  VendasDatasetnfexml_s3 := TStringField.Create(Self);
  VendasDatasetnfeanexo_sincronizado := TXDataWebDatasetField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);

  frmBanco.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  edtDataInicial.BeforeLoadDFMValues;
  edtDataFinal.BeforeLoadDFMValues;
  cbbVendasSimplesFaturamento.BeforeLoadDFMValues;
  cbxVendasExcluidos.BeforeLoadDFMValues;
  edtVendasCfop.BeforeLoadDFMValues;
  edtClienteNome.BeforeLoadDFMValues;
  btnPesquisarCliente.BeforeLoadDFMValues;
  btnPesquisarVenda.BeforeLoadDFMValues;
  frmBanco.BeforeLoadDFMValues;
  frmBanco.cbbDataBasePesquisa.BeforeLoadDFMValues;
  cbbVendasNfe.BeforeLoadDFMValues;
  VendasDataset.BeforeLoadDFMValues;
  VendasDatasetcodigo_interno.BeforeLoadDFMValues;
  VendasDatasetnumero.BeforeLoadDFMValues;
  VendasDatasetclienterazao_social_nome.BeforeLoadDFMValues;
  VendasDatasetdata_emissao.BeforeLoadDFMValues;
  VendasDatasetdata_saida.BeforeLoadDFMValues;
  VendasDatasetvalor_total.BeforeLoadDFMValues;
  VendasDatasetcfop_cfop.BeforeLoadDFMValues;
  VendasDatasetmodelo.BeforeLoadDFMValues;
  VendasDatasetserie.BeforeLoadDFMValues;
  VendasDatasetfuncionarionome.BeforeLoadDFMValues;
  VendasDatasetnfechave_acesso.BeforeLoadDFMValues;
  VendasDatasetexcluido.BeforeLoadDFMValues;
  VendasDatasetinclusao.BeforeLoadDFMValues;
  VendasDatasetalteracao.BeforeLoadDFMValues;
  VendasDatasetexclusao.BeforeLoadDFMValues;
  VendasDatasetid.BeforeLoadDFMValues;
  VendasDatasetnfe_id.BeforeLoadDFMValues;
  VendasDatasetnfexml_s3.BeforeLoadDFMValues;
  VendasDatasetnfeanexo_sincronizado.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  try
    Name := 'FViewVendasList';
    Width := 695;
    Height := 301;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 222;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 329;
    WebDBTableControl1.Height := 171;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 200;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero';
      Title := 'Documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cliente.razao_social_nome';
      Title := 'Cliente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_emissao';
      Title := 'Emiss'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_saida';
      Title := 'Sa'#237'da';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_cfop';
      Title := 'Cfop';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modelo';
      Title := 'modelo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'serie';
      Title := 'S'#233'rie';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario.nome';
      Title := 'Funcion'#225'rio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 216;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 216;
    lcPaginator.Top := 218;
    lcPaginator.Width := 121;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 352;
    btnExportarExcel.Top := 11;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    edtDataInicial.SetParentComponent(Self);
    edtDataInicial.Name := 'edtDataInicial';
    edtDataInicial.Left := 352;
    edtDataInicial.Top := 42;
    edtDataInicial.Width := 120;
    edtDataInicial.Height := 22;
    edtDataInicial.BorderStyle := bsSingle;
    edtDataInicial.ChildOrder := 109;
    edtDataInicial.Color := clWhite;
    edtDataInicial.Date := 45980.718362395830000000;
    edtDataInicial.Role := '';
    edtDataInicial.Text := '';
    edtDataFinal.SetParentComponent(Self);
    edtDataFinal.Name := 'edtDataFinal';
    edtDataFinal.Left := 352;
    edtDataFinal.Top := 70;
    edtDataFinal.Width := 120;
    edtDataFinal.Height := 22;
    edtDataFinal.BorderStyle := bsSingle;
    edtDataFinal.ChildOrder := 109;
    edtDataFinal.Color := clWhite;
    edtDataFinal.Date := 45980.718362395830000000;
    edtDataFinal.Role := '';
    edtDataFinal.Text := '';
    cbbVendasSimplesFaturamento.SetParentComponent(Self);
    cbbVendasSimplesFaturamento.Name := 'cbbVendasSimplesFaturamento';
    cbbVendasSimplesFaturamento.Left := 352;
    cbbVendasSimplesFaturamento.Top := 98;
    cbbVendasSimplesFaturamento.Width := 120;
    cbbVendasSimplesFaturamento.Height := 21;
    cbbVendasSimplesFaturamento.HeightPercent := 100.000000000000000000;
    cbbVendasSimplesFaturamento.Text := 'TODOS';
    cbbVendasSimplesFaturamento.WidthPercent := 100.000000000000000000;
    cbbVendasSimplesFaturamento.ItemIndex := 0;
    cbbVendasSimplesFaturamento.Items.BeginUpdate;
    try
      cbbVendasSimplesFaturamento.Items.Clear;
      cbbVendasSimplesFaturamento.Items.Add('TODOS');
      cbbVendasSimplesFaturamento.Items.Add('SIM');
      cbbVendasSimplesFaturamento.Items.Add('N'#195'O');
    finally
      cbbVendasSimplesFaturamento.Items.EndUpdate;
    end;
    cbxVendasExcluidos.SetParentComponent(Self);
    cbxVendasExcluidos.Name := 'cbxVendasExcluidos';
    cbxVendasExcluidos.Left := 494;
    cbxVendasExcluidos.Top := 70;
    cbxVendasExcluidos.Width := 151;
    cbxVendasExcluidos.Height := 22;
    cbxVendasExcluidos.Caption := 'Exibir Exclu'#237'dos?';
    cbxVendasExcluidos.ChildOrder := 9;
    cbxVendasExcluidos.HeightPercent := 100.000000000000000000;
    cbxVendasExcluidos.WidthPercent := 100.000000000000000000;
    edtVendasCfop.SetParentComponent(Self);
    edtVendasCfop.Name := 'edtVendasCfop';
    edtVendasCfop.Left := 494;
    edtVendasCfop.Top := 98;
    edtVendasCfop.Width := 151;
    edtVendasCfop.Height := 22;
    edtVendasCfop.ChildOrder := 10;
    edtVendasCfop.HeightPercent := 100.000000000000000000;
    edtVendasCfop.MaxLength := 4;
    edtVendasCfop.WidthPercent := 100.000000000000000000;
    SetEvent(edtVendasCfop, Self, 'OnKeyPress', 'edtVendasCfopKeyPress');
    edtClienteNome.SetParentComponent(Self);
    edtClienteNome.Name := 'edtClienteNome';
    edtClienteNome.Left := 494;
    edtClienteNome.Top := 42;
    edtClienteNome.Width := 120;
    edtClienteNome.Height := 22;
    edtClienteNome.ChildOrder := 21;
    edtClienteNome.Enabled := False;
    edtClienteNome.HeightPercent := 100.000000000000000000;
    edtClienteNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCliente.SetParentComponent(Self);
    btnPesquisarCliente.Name := 'btnPesquisarCliente';
    btnPesquisarCliente.Left := 615;
    btnPesquisarCliente.Top := 42;
    btnPesquisarCliente.Width := 30;
    btnPesquisarCliente.Height := 22;
    btnPesquisarCliente.ChildOrder := 22;
    btnPesquisarCliente.HeightPercent := 100.000000000000000000;
    btnPesquisarCliente.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCliente, Self, 'OnClick', 'btnPesquisarClienteClick');
    btnPesquisarVenda.SetParentComponent(Self);
    btnPesquisarVenda.Name := 'btnPesquisarVenda';
    btnPesquisarVenda.Left := 352;
    btnPesquisarVenda.Top := 228;
    btnPesquisarVenda.Width := 96;
    btnPesquisarVenda.Height := 25;
    btnPesquisarVenda.Caption := 'Pesquisar';
    btnPesquisarVenda.ChildOrder := 11;
    btnPesquisarVenda.HeightPercent := 100.000000000000000000;
    btnPesquisarVenda.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarVenda, Self, 'OnClick', 'btnPesquisarVendaClick');
    frmBanco.SetParentComponent(Self);
    frmBanco.Name := 'frmBanco';
    frmBanco.Left := 352;
    frmBanco.Top := 158;
    frmBanco.Width := 215;
    frmBanco.Height := 61;
    frmBanco.TabOrder := 13;
    frmBanco.Visible := False;
    frmBanco.cbbDataBasePesquisa.Height := 21;
    cbbVendasNfe.SetParentComponent(Self);
    cbbVendasNfe.Name := 'cbbVendasNfe';
    cbbVendasNfe.Left := 352;
    cbbVendasNfe.Top := 125;
    cbbVendasNfe.Width := 120;
    cbbVendasNfe.Height := 21;
    cbbVendasNfe.HeightPercent := 100.000000000000000000;
    cbbVendasNfe.Text := 'TODOS';
    cbbVendasNfe.WidthPercent := 100.000000000000000000;
    cbbVendasNfe.ItemIndex := 0;
    cbbVendasNfe.Items.BeginUpdate;
    try
      cbbVendasNfe.Items.Clear;
      cbbVendasNfe.Items.Add('TODOS');
      cbbVendasNfe.Items.Add('SIM');
      cbbVendasNfe.Items.Add('N'#195'O');
    finally
      cbbVendasNfe.Items.EndUpdate;
    end;
    VendasDataset.SetParentComponent(Self);
    VendasDataset.Name := 'VendasDataset';
    VendasDataset.EntitySetName := 'Vendas';
    VendasDataset.Connection := DMConnection.ApiConnection;
    VendasDataset.Left := 72;
    VendasDataset.Top := 88;
    VendasDatasetcodigo_interno.SetParentComponent(VendasDataset);
    VendasDatasetcodigo_interno.Name := 'VendasDatasetcodigo_interno';
    VendasDatasetcodigo_interno.FieldName := 'codigo_interno';
    VendasDatasetcodigo_interno.Required := True;
    VendasDatasetnumero.SetParentComponent(VendasDataset);
    VendasDatasetnumero.Name := 'VendasDatasetnumero';
    VendasDatasetnumero.FieldName := 'numero';
    VendasDatasetnumero.Required := True;
    VendasDatasetnumero.Size := 255;
    VendasDatasetclienterazao_social_nome.SetParentComponent(VendasDataset);
    VendasDatasetclienterazao_social_nome.Name := 'VendasDatasetclienterazao_social_nome';
    VendasDatasetclienterazao_social_nome.FieldName := 'cliente.razao_social_nome';
    VendasDatasetdata_emissao.SetParentComponent(VendasDataset);
    VendasDatasetdata_emissao.Name := 'VendasDatasetdata_emissao';
    VendasDatasetdata_emissao.FieldName := 'data_emissao';
    VendasDatasetdata_emissao.Required := True;
    VendasDatasetdata_emissao.DisplayFormat := 'dd/mm/yy';
    VendasDatasetdata_saida.SetParentComponent(VendasDataset);
    VendasDatasetdata_saida.Name := 'VendasDatasetdata_saida';
    VendasDatasetdata_saida.FieldName := 'data_saida';
    VendasDatasetdata_saida.DisplayFormat := 'dd/mm/yy';
    VendasDatasetvalor_total.SetParentComponent(VendasDataset);
    VendasDatasetvalor_total.Name := 'VendasDatasetvalor_total';
    VendasDatasetvalor_total.FieldName := 'valor_total';
    VendasDatasetvalor_total.Required := True;
    VendasDatasetvalor_total.DisplayFormat := '#,##0.00';
    VendasDatasetcfop_cfop.SetParentComponent(VendasDataset);
    VendasDatasetcfop_cfop.Name := 'VendasDatasetcfop_cfop';
    VendasDatasetcfop_cfop.FieldName := 'cfop_cfop';
    VendasDatasetcfop_cfop.Required := True;
    VendasDatasetcfop_cfop.Size := 255;
    VendasDatasetmodelo.SetParentComponent(VendasDataset);
    VendasDatasetmodelo.Name := 'VendasDatasetmodelo';
    VendasDatasetmodelo.FieldName := 'modelo';
    VendasDatasetmodelo.Size := 255;
    VendasDatasetserie.SetParentComponent(VendasDataset);
    VendasDatasetserie.Name := 'VendasDatasetserie';
    VendasDatasetserie.FieldName := 'serie';
    VendasDatasetserie.Size := 255;
    VendasDatasetfuncionarionome.SetParentComponent(VendasDataset);
    VendasDatasetfuncionarionome.Name := 'VendasDatasetfuncionarionome';
    VendasDatasetfuncionarionome.FieldName := 'funcionario.nome';
    VendasDatasetnfechave_acesso.SetParentComponent(VendasDataset);
    VendasDatasetnfechave_acesso.Name := 'VendasDatasetnfechave_acesso';
    VendasDatasetnfechave_acesso.Tag := 3;
    VendasDatasetnfechave_acesso.FieldName := 'nfe.chave_acesso';
    VendasDatasetexcluido.SetParentComponent(VendasDataset);
    VendasDatasetexcluido.Name := 'VendasDatasetexcluido';
    VendasDatasetexcluido.FieldName := 'excluido';
    VendasDatasetinclusao.SetParentComponent(VendasDataset);
    VendasDatasetinclusao.Name := 'VendasDatasetinclusao';
    VendasDatasetinclusao.FieldName := 'inclusao';
    VendasDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    VendasDatasetalteracao.SetParentComponent(VendasDataset);
    VendasDatasetalteracao.Name := 'VendasDatasetalteracao';
    VendasDatasetalteracao.FieldName := 'alteracao';
    VendasDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    VendasDatasetexclusao.SetParentComponent(VendasDataset);
    VendasDatasetexclusao.Name := 'VendasDatasetexclusao';
    VendasDatasetexclusao.FieldName := 'exclusao';
    VendasDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    VendasDatasetid.SetParentComponent(VendasDataset);
    VendasDatasetid.Name := 'VendasDatasetid';
    VendasDatasetid.Tag := 1;
    VendasDatasetid.FieldName := 'id';
    VendasDatasetid.Required := True;
    VendasDatasetnfe_id.SetParentComponent(VendasDataset);
    VendasDatasetnfe_id.Name := 'VendasDatasetnfe_id';
    VendasDatasetnfe_id.Tag := 1;
    VendasDatasetnfe_id.FieldName := 'nfe_id';
    VendasDatasetnfexml_s3.SetParentComponent(VendasDataset);
    VendasDatasetnfexml_s3.Name := 'VendasDatasetnfexml_s3';
    VendasDatasetnfexml_s3.Tag := 1;
    VendasDatasetnfexml_s3.FieldName := 'nfe.xml_s3';
    VendasDatasetnfeanexo_sincronizado.SetParentComponent(VendasDataset);
    VendasDatasetnfeanexo_sincronizado.Name := 'VendasDatasetnfeanexo_sincronizado';
    VendasDatasetnfeanexo_sincronizado.Tag := 1;
    VendasDatasetnfeanexo_sincronizado.FieldName := 'nfe.anexo_sincronizado';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := VendasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 144;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 168;
    tmrConsulta.Top := 104;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClient, Self, 'OnLoad', 'XDataWebClientLoad');
    SetEvent(XDataWebClient, Self, 'OnError', 'XDataWebClientError');
    XDataWebClient.Left := 472;
    XDataWebClient.Top := 256;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    edtDataInicial.AfterLoadDFMValues;
    edtDataFinal.AfterLoadDFMValues;
    cbbVendasSimplesFaturamento.AfterLoadDFMValues;
    cbxVendasExcluidos.AfterLoadDFMValues;
    edtVendasCfop.AfterLoadDFMValues;
    edtClienteNome.AfterLoadDFMValues;
    btnPesquisarCliente.AfterLoadDFMValues;
    btnPesquisarVenda.AfterLoadDFMValues;
    frmBanco.AfterLoadDFMValues;
    frmBanco.cbbDataBasePesquisa.AfterLoadDFMValues;
    cbbVendasNfe.AfterLoadDFMValues;
    VendasDataset.AfterLoadDFMValues;
    VendasDatasetcodigo_interno.AfterLoadDFMValues;
    VendasDatasetnumero.AfterLoadDFMValues;
    VendasDatasetclienterazao_social_nome.AfterLoadDFMValues;
    VendasDatasetdata_emissao.AfterLoadDFMValues;
    VendasDatasetdata_saida.AfterLoadDFMValues;
    VendasDatasetvalor_total.AfterLoadDFMValues;
    VendasDatasetcfop_cfop.AfterLoadDFMValues;
    VendasDatasetmodelo.AfterLoadDFMValues;
    VendasDatasetserie.AfterLoadDFMValues;
    VendasDatasetfuncionarionome.AfterLoadDFMValues;
    VendasDatasetnfechave_acesso.AfterLoadDFMValues;
    VendasDatasetexcluido.AfterLoadDFMValues;
    VendasDatasetinclusao.AfterLoadDFMValues;
    VendasDatasetalteracao.AfterLoadDFMValues;
    VendasDatasetexclusao.AfterLoadDFMValues;
    VendasDatasetid.AfterLoadDFMValues;
    VendasDatasetnfe_id.AfterLoadDFMValues;
    VendasDatasetnfexml_s3.AfterLoadDFMValues;
    VendasDatasetnfeanexo_sincronizado.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
  end;
end;

end.
